/* eslint-disable space-infix-ops */
/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import styled, { css } from 'styled-components';
import uiDevice from '@deprecated-ui/_style/device';

interface IContainer {
  isFlexibleWidth: boolean;
  isSideWidgetOpen?: boolean;
  maxWidth: number;
  fullPage?: boolean;
}
interface IWrapper {
  background?: string;
  isSideWidgetOpen?: boolean;
}

// TODO: Update device dimension to DS
const laptopM = '(min-width:1081px)';
export const device = { ...uiDevice, laptopM };
export const SIDE_WIDGET_CONTENT_WIDTH = '330px';
export const SIDE_WIDGET_TOOLBAR_WIDTH = '35px';
export const SIDE_WIDGET_OPENED_WIDTH = '365px';

// prettier-ignore
const Container = styled.main < IContainer >`
  margin: 40px auto 0 auto;
  padding: ${(props) => (props.fullPage ? '0' : '20px 0')};
  width: 100%;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '990px')};

  &.chat-expanded {
    margin: 0 auto 0 auto !important;
    padding: 0 !important;
  }

  ${(props) =>
    props.isFlexibleWidth &&
    css`
      @media ${device.tablet} {
        width: calc(100% - 60px);
      }
    `}

  @media ${device.tablet} {
    margin: 100px auto 0 auto;
    max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '660px')};

    &.chat-expanded {
      margin: 0px auto 0 auto !important;
      padding: 20px 37px 0 0 !important;
    }
  }

  @media ${device.laptopM} {
    max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '990px')};
  }
`;

export const Wrapper = styled.div<IWrapper>`
  background: ${(props) =>
    props.background ? props.background : 'transparent'};
  width: 100%;

  @media ${device.tablet} {
    width: calc(100% - ${SIDE_WIDGET_TOOLBAR_WIDTH});

    ${(props) =>
      props.isSideWidgetOpen &&
      css`
        width: calc(
          100% - (${SIDE_WIDGET_TOOLBAR_WIDTH} + ${SIDE_WIDGET_CONTENT_WIDTH})
        );
      `}
  }
`;

export default Container;
